<div class="will-be-lost">
  <div class="cd-waring-popup">
    <div>
      <div innerHtml="{{ 'common.action.will-be-lose-input' | lang }}"></div>
    </div>
    <div class="botton-list" [ngClass]="deviceOrientationService.isMobilePortrait ? 'mobile' : ''">
      <div>
        <cds-button [style]="'secondary'" size="sm" (click)="onCancel()">{{ 'common.cancel' | lang }}</cds-button>
      </div>
      <div [ngClass]="deviceOrientationService.isMobilePortrait ? 'l-mt-4' : 'l-ml-4'">
        <cds-button size="sm" (click)="onContinue()">{{ 'common.confirm-continue' | lang }}</cds-button>
      </div>
    </div>
  </div>
</div>
